/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as pavilionPavilionRouteImport } from './routes/(pavilion)/pavilion'
import { Route as codegenCodegenRouteImport } from './routes/(codegen)/codegen'
import { Route as authWaitinglistRouteImport } from './routes/(auth)/waitinglist'
import { Route as authAuthRouteImport } from './routes/(auth)/auth'
import { Route as pavilionPavilionIndexRouteImport } from './routes/(pavilion)/pavilion.index'
import { Route as codegenCodegenIndexRouteImport } from './routes/(codegen)/codegen.index'
import { Route as authWaitinglistIndexRouteImport } from './routes/(auth)/waitinglist.index'
import { Route as authAuthIndexRouteImport } from './routes/(auth)/auth.index'
import { Route as pavilionPavilionNewRouteImport } from './routes/(pavilion)/pavilion/new'
import { Route as pavilionPavilionAgentNameRouteImport } from './routes/(pavilion)/pavilion/$agentName'
import { Route as codegenCodegenProjectIdRouteImport } from './routes/(codegen)/codegen/$projectId'
import { Route as codegenCodegenProjectIdFilesystemSnapshotIdRouteImport } from './routes/(codegen)/codegen/$projectId/filesystem/$snapshotId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const pavilionPavilionRoute = pavilionPavilionRouteImport.update({
  id: '/(pavilion)/pavilion',
  path: '/pavilion',
  getParentRoute: () => rootRouteImport,
} as any)
const codegenCodegenRoute = codegenCodegenRouteImport.update({
  id: '/(codegen)/codegen',
  path: '/codegen',
  getParentRoute: () => rootRouteImport,
} as any)
const authWaitinglistRoute = authWaitinglistRouteImport.update({
  id: '/(auth)/waitinglist',
  path: '/waitinglist',
  getParentRoute: () => rootRouteImport,
} as any)
const authAuthRoute = authAuthRouteImport.update({
  id: '/(auth)/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const pavilionPavilionIndexRoute = pavilionPavilionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => pavilionPavilionRoute,
} as any)
const codegenCodegenIndexRoute = codegenCodegenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => codegenCodegenRoute,
} as any)
const authWaitinglistIndexRoute = authWaitinglistIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authWaitinglistRoute,
} as any)
const authAuthIndexRoute = authAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authAuthRoute,
} as any)
const pavilionPavilionNewRoute = pavilionPavilionNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => pavilionPavilionRoute,
} as any)
const pavilionPavilionAgentNameRoute =
  pavilionPavilionAgentNameRouteImport.update({
    id: '/$agentName',
    path: '/$agentName',
    getParentRoute: () => pavilionPavilionRoute,
  } as any)
const codegenCodegenProjectIdRoute = codegenCodegenProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => codegenCodegenRoute,
} as any)
const codegenCodegenProjectIdFilesystemSnapshotIdRoute =
  codegenCodegenProjectIdFilesystemSnapshotIdRouteImport.update({
    id: '/filesystem/$snapshotId',
    path: '/filesystem/$snapshotId',
    getParentRoute: () => codegenCodegenProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof authAuthRouteWithChildren
  '/waitinglist': typeof authWaitinglistRouteWithChildren
  '/codegen': typeof codegenCodegenRouteWithChildren
  '/pavilion': typeof pavilionPavilionRouteWithChildren
  '/codegen/$projectId': typeof codegenCodegenProjectIdRouteWithChildren
  '/pavilion/$agentName': typeof pavilionPavilionAgentNameRoute
  '/pavilion/new': typeof pavilionPavilionNewRoute
  '/auth/': typeof authAuthIndexRoute
  '/waitinglist/': typeof authWaitinglistIndexRoute
  '/codegen/': typeof codegenCodegenIndexRoute
  '/pavilion/': typeof pavilionPavilionIndexRoute
  '/codegen/$projectId/filesystem/$snapshotId': typeof codegenCodegenProjectIdFilesystemSnapshotIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/codegen/$projectId': typeof codegenCodegenProjectIdRouteWithChildren
  '/pavilion/$agentName': typeof pavilionPavilionAgentNameRoute
  '/pavilion/new': typeof pavilionPavilionNewRoute
  '/auth': typeof authAuthIndexRoute
  '/waitinglist': typeof authWaitinglistIndexRoute
  '/codegen': typeof codegenCodegenIndexRoute
  '/pavilion': typeof pavilionPavilionIndexRoute
  '/codegen/$projectId/filesystem/$snapshotId': typeof codegenCodegenProjectIdFilesystemSnapshotIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)/auth': typeof authAuthRouteWithChildren
  '/(auth)/waitinglist': typeof authWaitinglistRouteWithChildren
  '/(codegen)/codegen': typeof codegenCodegenRouteWithChildren
  '/(pavilion)/pavilion': typeof pavilionPavilionRouteWithChildren
  '/(codegen)/codegen/$projectId': typeof codegenCodegenProjectIdRouteWithChildren
  '/(pavilion)/pavilion/$agentName': typeof pavilionPavilionAgentNameRoute
  '/(pavilion)/pavilion/new': typeof pavilionPavilionNewRoute
  '/(auth)/auth/': typeof authAuthIndexRoute
  '/(auth)/waitinglist/': typeof authWaitinglistIndexRoute
  '/(codegen)/codegen/': typeof codegenCodegenIndexRoute
  '/(pavilion)/pavilion/': typeof pavilionPavilionIndexRoute
  '/(codegen)/codegen/$projectId/filesystem/$snapshotId': typeof codegenCodegenProjectIdFilesystemSnapshotIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/waitinglist'
    | '/codegen'
    | '/pavilion'
    | '/codegen/$projectId'
    | '/pavilion/$agentName'
    | '/pavilion/new'
    | '/auth/'
    | '/waitinglist/'
    | '/codegen/'
    | '/pavilion/'
    | '/codegen/$projectId/filesystem/$snapshotId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/codegen/$projectId'
    | '/pavilion/$agentName'
    | '/pavilion/new'
    | '/auth'
    | '/waitinglist'
    | '/codegen'
    | '/pavilion'
    | '/codegen/$projectId/filesystem/$snapshotId'
  id:
    | '__root__'
    | '/'
    | '/(auth)/auth'
    | '/(auth)/waitinglist'
    | '/(codegen)/codegen'
    | '/(pavilion)/pavilion'
    | '/(codegen)/codegen/$projectId'
    | '/(pavilion)/pavilion/$agentName'
    | '/(pavilion)/pavilion/new'
    | '/(auth)/auth/'
    | '/(auth)/waitinglist/'
    | '/(codegen)/codegen/'
    | '/(pavilion)/pavilion/'
    | '/(codegen)/codegen/$projectId/filesystem/$snapshotId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authAuthRoute: typeof authAuthRouteWithChildren
  authWaitinglistRoute: typeof authWaitinglistRouteWithChildren
  codegenCodegenRoute: typeof codegenCodegenRouteWithChildren
  pavilionPavilionRoute: typeof pavilionPavilionRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(pavilion)/pavilion': {
      id: '/(pavilion)/pavilion'
      path: '/pavilion'
      fullPath: '/pavilion'
      preLoaderRoute: typeof pavilionPavilionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(codegen)/codegen': {
      id: '/(codegen)/codegen'
      path: '/codegen'
      fullPath: '/codegen'
      preLoaderRoute: typeof codegenCodegenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/waitinglist': {
      id: '/(auth)/waitinglist'
      path: '/waitinglist'
      fullPath: '/waitinglist'
      preLoaderRoute: typeof authWaitinglistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/auth': {
      id: '/(auth)/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(pavilion)/pavilion/': {
      id: '/(pavilion)/pavilion/'
      path: '/'
      fullPath: '/pavilion/'
      preLoaderRoute: typeof pavilionPavilionIndexRouteImport
      parentRoute: typeof pavilionPavilionRoute
    }
    '/(codegen)/codegen/': {
      id: '/(codegen)/codegen/'
      path: '/'
      fullPath: '/codegen/'
      preLoaderRoute: typeof codegenCodegenIndexRouteImport
      parentRoute: typeof codegenCodegenRoute
    }
    '/(auth)/waitinglist/': {
      id: '/(auth)/waitinglist/'
      path: '/'
      fullPath: '/waitinglist/'
      preLoaderRoute: typeof authWaitinglistIndexRouteImport
      parentRoute: typeof authWaitinglistRoute
    }
    '/(auth)/auth/': {
      id: '/(auth)/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof authAuthIndexRouteImport
      parentRoute: typeof authAuthRoute
    }
    '/(pavilion)/pavilion/new': {
      id: '/(pavilion)/pavilion/new'
      path: '/new'
      fullPath: '/pavilion/new'
      preLoaderRoute: typeof pavilionPavilionNewRouteImport
      parentRoute: typeof pavilionPavilionRoute
    }
    '/(pavilion)/pavilion/$agentName': {
      id: '/(pavilion)/pavilion/$agentName'
      path: '/$agentName'
      fullPath: '/pavilion/$agentName'
      preLoaderRoute: typeof pavilionPavilionAgentNameRouteImport
      parentRoute: typeof pavilionPavilionRoute
    }
    '/(codegen)/codegen/$projectId': {
      id: '/(codegen)/codegen/$projectId'
      path: '/$projectId'
      fullPath: '/codegen/$projectId'
      preLoaderRoute: typeof codegenCodegenProjectIdRouteImport
      parentRoute: typeof codegenCodegenRoute
    }
    '/(codegen)/codegen/$projectId/filesystem/$snapshotId': {
      id: '/(codegen)/codegen/$projectId/filesystem/$snapshotId'
      path: '/filesystem/$snapshotId'
      fullPath: '/codegen/$projectId/filesystem/$snapshotId'
      preLoaderRoute: typeof codegenCodegenProjectIdFilesystemSnapshotIdRouteImport
      parentRoute: typeof codegenCodegenProjectIdRoute
    }
  }
}

interface authAuthRouteChildren {
  authAuthIndexRoute: typeof authAuthIndexRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthIndexRoute: authAuthIndexRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

interface authWaitinglistRouteChildren {
  authWaitinglistIndexRoute: typeof authWaitinglistIndexRoute
}

const authWaitinglistRouteChildren: authWaitinglistRouteChildren = {
  authWaitinglistIndexRoute: authWaitinglistIndexRoute,
}

const authWaitinglistRouteWithChildren = authWaitinglistRoute._addFileChildren(
  authWaitinglistRouteChildren,
)

interface codegenCodegenProjectIdRouteChildren {
  codegenCodegenProjectIdFilesystemSnapshotIdRoute: typeof codegenCodegenProjectIdFilesystemSnapshotIdRoute
}

const codegenCodegenProjectIdRouteChildren: codegenCodegenProjectIdRouteChildren =
  {
    codegenCodegenProjectIdFilesystemSnapshotIdRoute:
      codegenCodegenProjectIdFilesystemSnapshotIdRoute,
  }

const codegenCodegenProjectIdRouteWithChildren =
  codegenCodegenProjectIdRoute._addFileChildren(
    codegenCodegenProjectIdRouteChildren,
  )

interface codegenCodegenRouteChildren {
  codegenCodegenProjectIdRoute: typeof codegenCodegenProjectIdRouteWithChildren
  codegenCodegenIndexRoute: typeof codegenCodegenIndexRoute
}

const codegenCodegenRouteChildren: codegenCodegenRouteChildren = {
  codegenCodegenProjectIdRoute: codegenCodegenProjectIdRouteWithChildren,
  codegenCodegenIndexRoute: codegenCodegenIndexRoute,
}

const codegenCodegenRouteWithChildren = codegenCodegenRoute._addFileChildren(
  codegenCodegenRouteChildren,
)

interface pavilionPavilionRouteChildren {
  pavilionPavilionAgentNameRoute: typeof pavilionPavilionAgentNameRoute
  pavilionPavilionNewRoute: typeof pavilionPavilionNewRoute
  pavilionPavilionIndexRoute: typeof pavilionPavilionIndexRoute
}

const pavilionPavilionRouteChildren: pavilionPavilionRouteChildren = {
  pavilionPavilionAgentNameRoute: pavilionPavilionAgentNameRoute,
  pavilionPavilionNewRoute: pavilionPavilionNewRoute,
  pavilionPavilionIndexRoute: pavilionPavilionIndexRoute,
}

const pavilionPavilionRouteWithChildren =
  pavilionPavilionRoute._addFileChildren(pavilionPavilionRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authAuthRoute: authAuthRouteWithChildren,
  authWaitinglistRoute: authWaitinglistRouteWithChildren,
  codegenCodegenRoute: codegenCodegenRouteWithChildren,
  pavilionPavilionRoute: pavilionPavilionRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
